import s from './classnames.scss'

export const namesToClasses = (names: string) => {
  return names
    .split(' ')
    .map(name => s[name] || console.log(`${name} class not found`) || name)
    .join(' ')
}
